if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}

/* =========================================================
   ShadeCentral v10 – the colour row is the photo picker
   - Every photo is a colour photo (data-sc-colour) or a shared photo
     (data-sc-label: "In the box", "Size guide" …), set by snippets/sc-media-attrs.
   - Choosing a colour shows that colour's photos, then the shared ones.
   - No thumbnails: the colour row ends with one tile per kind of shared photo. Tapping one
     shows it and the label reads e.g. "In the box" instead of the colour; the
     chosen colour keeps an outline because it is still what goes in the basket.
   - Swipe (phone) or the arrows (desktop) move through the photos and the label
     follows the photo on screen.
   - v11: while a shared photo is on screen, Add to cart and Buy it now wait
     ("Choose a colour") until a colour is tapped or its photo is back on screen.
     Not used when there is only one colour, when the picked colour has no photos of
     its own, or for the "More photos" row of products without a colour option.
   ========================================================= */
(function () {
  if (window.__scVariantSync) return;
  window.__scVariantSync = true;

  var ICON_PREV = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_NEXT = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function debounce(fn, wait) {
    var t;
    return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, wait); };
  }
  function toArray(list) { return Array.prototype.slice.call(list || []); }

  function init() {
    var VR = customElements.get('variant-radios');
    if (VR && !VR.prototype.__scPatched) {
      var origUpdateMedia = VR.prototype.updateMedia;
      VR.prototype.updateMedia = function () {
        if (this.__scSkipMedia) return;
        return origUpdateMedia.apply(this, arguments);
      };
      VR.prototype.__scPatched = true;
    }
    // when Dawn updates the buy button (e.g. after a colour change), keep it waiting
    // if a shared photo is still on screen
    var VS = customElements.get('variant-selects');
    if (VS && !VS.prototype.__scBuyPatched) {
      var origToggle = VS.prototype.toggleAddButton;
      VS.prototype.toggleAddButton = function () {
        var r = origToggle.apply(this, arguments);
        var f = document.getElementById('product-form-' + this.dataset.section);
        if (f && f.__scHoldBuy) f.__scHoldBuy();
        return r;
      };
      VS.prototype.__scBuyPatched = true;
    }

    document.querySelectorAll('variant-radios').forEach(function (picker) {
      if (picker.__scBound) return;
      picker.__scBound = true;

      var sectionId = picker.dataset.section;
      var variants;
      try { variants = JSON.parse(picker.querySelector('script[type="application/json"]').textContent); } catch (e) { return; }

      var fieldsets = function () { return toArray(picker.querySelectorAll('fieldset')); };
      function selectedValues() {
        return fieldsets().map(function (fs) { var c = fs.querySelector('input[type="radio"]:checked'); return c ? c.value : null; });
      }
      // the option that drives the photos: the one with picture swatches, else the first
      var colourIndex = 0, picked = false;
      fieldsets().forEach(function (fs, i) {
        if (!picked && (fs.classList.contains('sc-picker') || fs.querySelector('label.sc-swatch'))) { colourIndex = i; picked = true; }
      });
      var mediaColour = {};
      variants.forEach(function (v) { if (v.featured_media) mediaColour[String(v.featured_media.id)] = v.options[colourIndex]; });

      var galleries = toArray(document.querySelectorAll('[id^="MediaGallery-' + sectionId + '"]'));
      var prefix = sectionId + '-';
      function bare(id) { return String(id || '').replace(prefix, ''); }

      // what each photo shows
      var info = {};
      galleries.forEach(function (g) {
        g.querySelectorAll('li[data-media-id]').forEach(function (li) {
          var mid = bare(li.dataset.mediaId);
          info[mid] = { colour: li.dataset.scColour || mediaColour[mid] || '', label: li.dataset.scLabel || '' };
        });
      });
      var modalContent = document.querySelector('#ProductModal-' + sectionId + ' .product-media-modal__content');

      var pickerBox = picker.querySelector('.sc-picker');
      var tiles = pickerBox ? toArray(pickerBox.querySelectorAll('.sc-extra')) : [];
      var nameSpan = pickerBox ? pickerBox.querySelector('.sc-option-name') : null;
      var valueSpan = pickerBox ? pickerBox.querySelector('.sc-selected-value') : null;
      var photosRow = !!(pickerBox && pickerBox.classList.contains('sc-picker--photos'));

      function updateLegend() {
        fieldsets().forEach(function (fs) {
          var checked = fs.querySelector('input[type="radio"]:checked');
          var span = fs.querySelector('.sc-selected-value');
          var nm = fs.querySelector('.sc-option-name');
          if (nm && nm.dataset.scName) nm.textContent = nm.dataset.scName;
          if (checked && span) span.textContent = checked.value;
        });
      }

      // buying waits while a shared photo (size guide, details …) is on screen
      var productForm = document.getElementById('product-form-' + sectionId);
      var choiceCount = (pickerBox && !photosRow) ? pickerBox.querySelectorAll('input[type="radio"]').length : 0;
      var canHold = !!(productForm && choiceCount > 1);
      var held = false;
      function chooseText() {
        var nm = String((nameSpan && nameSpan.dataset.scName) || 'colour').toLowerCase();
        return 'Choose ' + (/^[aeiou]/.test(nm) ? 'an ' : 'a ') + nm;
      }
      function buyParts() {
        var btn = productForm ? productForm.querySelector('[name="add"]') : null;
        var text = btn ? (btn.querySelector(':scope > span') || btn.querySelector('span')) : null;
        var pay = productForm ? productForm.querySelector('.shopify-payment-button') : null;
        return { btn: btn, text: text, pay: pay };
      }
      function hold() {
        var p = buyParts();
        if (!p.btn) return;
        productForm.classList.add('sc-buy-off');
        p.btn.setAttribute('disabled', 'disabled');
        if (p.text) p.text.textContent = chooseText();
        if (p.pay) { p.pay.setAttribute('inert', ''); p.pay.style.opacity = '0.45'; }
      }
      function release() {
        var p = buyParts();
        productForm.classList.remove('sc-buy-off');
        if (p.pay) { p.pay.removeAttribute('inert'); p.pay.style.opacity = ''; }
        if (!p.btn) return;
        var vals = selectedValues();
        var v = variants.filter(function (x) {
          return x.options.every(function (o, i) { return o === vals[i]; });
        })[0];
        var s = window.variantStrings || {};
        if (v && v.available) {
          p.btn.removeAttribute('disabled');
          if (p.text) p.text.textContent = s.addToCart || 'Add to cart';
        } else {
          p.btn.setAttribute('disabled', 'disabled');
          if (p.text) p.text.textContent = v ? (s.soldOut || 'Sold out') : (s.unavailable || 'Unavailable');
        }
      }
      function setBuy(off) {
        if (!canHold) return;
        if (off) { held = true; hold(); }
        else if (held) { held = false; release(); }
      }
      if (productForm) productForm.__scHoldBuy = function () { if (held) hold(); };
      // only wait when the picked colour has a photo to go back to
      function colourHasPhotos() {
        var colour = selectedValues()[colourIndex];
        if (!colour) return false;
        for (var k in info) { if (info[k].colour === colour) return true; }
        return false;
      }

      // label + tiles follow the photo on screen
      function showing(mid) {
        var inf = info[mid];
        var shared = !!(inf && !inf.colour);
        var lab = shared ? (inf.label || 'More photos') : '';
        // one tile per kind of shared photo: it stays lit for every photo of that kind
        tiles.forEach(function (t) {
          t.setAttribute('aria-pressed', shared && t.dataset.scLabel === lab ? 'true' : 'false');
        });
        picker.classList.toggle('sc-viewing-extra', shared);
        setBuy(shared && colourHasPhotos());
        if (!pickerBox) return;
        if (photosRow) {
          if (valueSpan) valueSpan.textContent = lab;
          return;
        }
        if (shared) {
          if (nameSpan) nameSpan.textContent = lab;
          if (valueSpan) valueSpan.textContent = '';
        } else {
          if (nameSpan) nameSpan.textContent = nameSpan.dataset.scName || nameSpan.textContent;
          var checked = pickerBox.querySelector('input[type="radio"]:checked');
          if (valueSpan && checked) valueSpan.textContent = checked.value;
        }
      }

      function viewerOf(gallery) { return gallery.querySelector('[id^="GalleryViewer"]'); }
      function visibleItems(gallery) {
        var viewer = viewerOf(gallery);
        if (!viewer) return [];
        return toArray(viewer.querySelectorAll('li[data-media-id]')).filter(function (li) { return !li.classList.contains('sc-hidden'); });
      }
      function activeItem(gallery) {
        var viewer = viewerOf(gallery);
        return viewer ? viewer.querySelector('li[data-media-id].is-active') : null;
      }
      function updateCounter(gallery) {
        var box = gallery.querySelector('.sc-arrows__count');
        if (!box) return;
        var items = visibleItems(gallery);
        var i = items.indexOf(activeItem(gallery));
        box.textContent = (i < 0 ? 1 : i + 1) + ' / ' + items.length;
      }
      function go(gallery, step) {
        var items = visibleItems(gallery);
        if (items.length < 2) return;
        var i = items.indexOf(activeItem(gallery));
        if (i < 0) i = 0;
        var next = items[(i + step + items.length) % items.length];
        gallery.setActiveMedia(next.dataset.mediaId, false);
        showing(bare(next.dataset.mediaId));
        updateCounter(gallery);
      }

      function applyFilter() {
        var colour = selectedValues()[colourIndex];
        galleries.forEach(function (gallery) {
          var viewer = viewerOf(gallery);
          var thumbs = gallery.querySelector('[id^="GalleryThumbnails"]');
          var shown = 0;
          toArray(gallery.querySelectorAll('li[data-media-id], li[data-target]')).forEach(function (li) {
            var mid = bare(li.dataset.mediaId || li.dataset.target);
            var c = (info[mid] && info[mid].colour) || li.dataset.scColour || mediaColour[mid] || '';
            var hide = !!(colour && c && c !== colour);
            li.classList.toggle('sc-hidden', hide);
            if (!hide && li.dataset.mediaId) shown++;
          });
          gallery.classList.toggle('sc-single', shown <= 1);
          var act = activeItem(gallery);
          var vis = visibleItems(gallery);
          if (vis.length && (!act || act.classList.contains('sc-hidden'))) {
            try { gallery.setActiveMedia(vis[0].dataset.mediaId, false); } catch (e) {}
          }
          if (viewer && viewer.resetPages) { try { viewer.resetPages(); } catch (e) {} }
          if (thumbs && thumbs.resetPages) { try { thumbs.resetPages(); } catch (e) {} }
          updateCounter(gallery);
        });
        if (modalContent) {
          toArray(modalContent.children).forEach(function (el) {
            var holder = el.matches('[data-media-id]') ? el : el.querySelector('[data-media-id]');
            if (!holder) return;
            var mid = String(holder.getAttribute('data-media-id') || '');
            var c = (info[mid] && info[mid].colour) || mediaColour[mid] || '';
            el.classList.toggle('sc-hidden', !!(colour && c && c !== colour));
          });
        }
      }

      function syncToActive() {
        var g = galleries[0];
        var a = g ? activeItem(g) : null;
        if (a) showing(bare(a.dataset.mediaId));
      }

      // tiles for shared photos
      tiles.forEach(function (t) {
        t.addEventListener('click', function () {
          var raw = t.dataset.scMedia;
          galleries.forEach(function (g) {
            try { g.setActiveMedia(raw, false); } catch (e) {}
            updateCounter(g);
          });
          showing(bare(raw));
          var g0 = galleries[0];
          if (g0) {
            var r = g0.getBoundingClientRect();
            if (r.bottom < 220) window.scrollBy({ top: r.top - 70, behavior: 'smooth' });
          }
        });
      });

      galleries.forEach(function (gallery) {
        var viewer = viewerOf(gallery);
        if (!viewer) return;
        // phone: swiping changes the photo on screen
        viewer.addEventListener('slideChanged', debounce(function (e) {
          var el = e.detail && e.detail.currentElement;
          if (el && el.dataset && el.dataset.mediaId) showing(bare(el.dataset.mediaId));
        }, 120));
        // desktop: arrows and a counter on the photo
        if (!viewer.querySelector('.sc-arrows')) {
          var box = document.createElement('div');
          box.className = 'sc-arrows';
          box.innerHTML = '<button type="button" class="sc-arrows__btn sc-arrows__btn--prev" aria-label="Previous photo">' + ICON_PREV + '</button>' +
            '<span class="sc-arrows__count" aria-hidden="true"></span>' +
            '<button type="button" class="sc-arrows__btn sc-arrows__btn--next" aria-label="Next photo">' + ICON_NEXT + '</button>';
          viewer.appendChild(box);
          box.querySelector('.sc-arrows__btn--prev').addEventListener('click', function () { go(gallery, -1); });
          box.querySelector('.sc-arrows__btn--next').addEventListener('click', function () { go(gallery, 1); });
        }
      });

      // tapping the colour that is already chosen goes back to its photo
      picker.addEventListener('click', function (e) {
        var lab = e.target.closest ? e.target.closest('label') : null;
        if (!lab || !lab.htmlFor) return;
        var input = document.getElementById(lab.htmlFor);
        if (!input || !input.checked || !picker.classList.contains('sc-viewing-extra')) return;
        var colour = selectedValues()[colourIndex];
        galleries.forEach(function (g) {
          var first = visibleItems(g).filter(function (li) { var inf = info[bare(li.dataset.mediaId)]; return inf && inf.colour === colour; })[0];
          if (!first) return;
          try { g.setActiveMedia(first.dataset.mediaId, false); } catch (err) {}
          updateCounter(g);
        });
        syncToActive();
      });

      // desktop: load the photos of the chosen colour (and the shared ones) once the page is idle,
      // so the arrows and tiles show them straight away
      function warm() {
        if (!window.matchMedia('(min-width: 750px)').matches) return;
        galleries.forEach(function (g) {
          visibleItems(g).forEach(function (li) {
            li.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
          });
        });
      }
      function warmLater() { (window.requestIdleCallback || function (f) { return setTimeout(f, 800); })(warm); }

      picker.addEventListener('change', function () {
        updateLegend();
        setTimeout(function () { applyFilter(); syncToActive(); warmLater(); }, 0);
      });
      updateLegend();
      applyFilter();
      syncToActive();
      if (document.readyState === 'complete') warmLater();
      else window.addEventListener('load', warmLater);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
